import cx from 'classnames';
import { InputHTMLAttributes, ReactNode, useId } from 'react';
import css from './Radio.module.scss';

export interface IRadioProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label: ReactNode;
  size?: 'md' | 'lg';
  variant?: 'normal' | 'bordered';
}

export const Radio = ({
  className,
  disabled,
  label,
  size = 'md',
  variant = 'normal',
  ...rest
}: IRadioProps) => {
  const id = useId();
  return (
    <div
      className={cx(css.radio, css[size], css[variant], className, {
        [css.checked]: rest.checked,
        [css.disabled]: disabled,
      })}
    >
      <input disabled={disabled} type="radio" {...rest} id={id} />
      <label htmlFor={id}>
        <span className={css.customInput} />
        {label}
      </label>
    </div>
  );
};
